import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import moment from 'moment';
import 'moment/locale/ro';

function mapStateToProps(state) {
    const { lang, messages } = state.locale;
    // Set moment language
    moment.locale(lang);
    document.documentElement.lang = lang;
    return { locale: lang, key: lang, messages };
}

export default connect(mapStateToProps)(IntlProvider);
